import { useCallback } from 'react';
import { usePlotEditorContext } from './PlotEditorContext';

/**
 * Hook for consistent plot update patterns.
 * Provides typed helpers for common update operations.
 */
export function usePlotlyUpdate() {
  const { onUpdate } = usePlotEditorContext();

  const updateLayout = useCallback(
    (path: string, value: any) => {
      onUpdate(`layout.${path}`, value);
    },
    [onUpdate]
  );

  const updateTrace = useCallback(
    (traceIndex: number, path: string, value: any) => {
      onUpdate(`series.${traceIndex}.${path}`, value);
    },
    [onUpdate]
  );

  const applyOperation = useCallback(
    (op: string, args?: any) => {
      onUpdate(`op.${op}`, args ?? null);
    },
    [onUpdate]
  );

  const updateDesign = useCallback(
    (category: string, path: string, value: any) => {
      onUpdate(`design.${category}.${path}`, value);
    },
    [onUpdate]
  );

  const updateAxis = useCallback(
    (axis: 'x' | 'y' | 'x2' | 'y2', path: string, value: any) => {
      onUpdate(`axis.${axis}.${path}`, value);
    },
    [onUpdate]
  );

  return {
    updateLayout,
    updateTrace,
    applyOperation,
    updateDesign,
    updateAxis,
    onUpdate, // Direct access for complex cases
  };
}









